import { defineEntityOwner } from './types';

export const ideaOwnerDescriptor = defineEntityOwner('idea', {
  owningService: 'fim',
  clientPackage: null,
  cdcTopic: null,
  resolveLink: (entityId, ctx) =>
    `/org-id/${ctx.organizationId}/intake/ideas/all?ideaId=${entityId}`,
  resolveLabels: null,
});
